import { ChecklistActions } from './actions'

export const CHECKLIST_NAMESPACE = 'checklist'

export const Checklist = {
  actions: ChecklistActions,
  getters: {},
  mutations: {},
  namespaced: true,
  state: {},
}
